// First words with you (alphabet) — format page: pick Standard/Premium, POST to backend
// (bookType=alphabet), then add the matching variant to cart.
document.addEventListener("DOMContentLoaded", async function () {
  const continueBtn = document.getElementById("continue-to-cart");
  const loader = document.getElementById("format-initial-loader");
  const errorElement = document.getElementById("api-error");

  const profile = await loadProfile();
  if (!profile) {
    window.location.replace("/pages/personalise-book-alphabet");
    return;
  }

  const DEFAULT_DEDICATION = (name) =>
    "This little alphabet book is a gift for you " + (name || "") + ".\n" +
    "May Allah fill your heart with kindness,\n" +
    "help you learn something new every day,\n" +
    "and bless you with happiness wherever you go.";

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  }

  async function buildFormData() {
    const selectedFormat = document.querySelector('input[name="book-format"]:checked').value;
    const profile = await loadProfile();
    const childName = profile?.name;
    const customText = profile?.dedicationText;
    const dataURL = profile?.imageBase64;

    const formData = new FormData();
    formData.append("firstName", childName || "");
    formData.append("gender", (profile?.gender || "BOY").toUpperCase());
    formData.append("bookType", "alphabet");
    formData.append("skinTone", profile?.skinTone === "dark" ? "dark" : "light");
    formData.append("customText", customText || DEFAULT_DEDICATION(childName));
    formData.append("coverType", selectedFormat === "premium" ? "HARD" : "SOFT");
    if (dataURL) {
      const blob = dataURLtoBlob(dataURL);
      const imageFile = new File([blob], "photo.png", { type: "image/png" });
      formData.append("image", imageFile);
    }
    return formData;
  }

  continueBtn?.addEventListener("click", async function () {
    const selectedFormat = document.querySelector('input[name="book-format"]:checked').value;
    const isPhotoUploaded = Boolean(profile?.imageBase64);

    // Alphabet "First words with you" variant IDs (created 2026-07-24)
    const standardVariantId = 54471990706522;          // Standard book (SOFT)
    const premiumVariantId = 54471990739290;           // Premium cover (HARD)
    const standardWithPhotoVariantId = 54471990772058; // Standard book (With Photo Addon)
    const premiumWithPhotoVariantId = 54471990804826;  // Premium cover (With Photo Addon)

    const selectedVariantId =
      selectedFormat === "premium"
        ? (isPhotoUploaded ? premiumWithPhotoVariantId : premiumVariantId)
        : (isPhotoUploaded ? standardWithPhotoVariantId : standardVariantId);

    const symbol = Shopify.currency.active === 'USD' ? "$" : "£";

    let price;
    if (Shopify.currency.active === 'USD') {
      price = selectedFormat === "premium" ? "54.99" : "39.99";
    } else {
      price = (Shopify.currency.rate * (selectedFormat === "premium" ? 39.99 : 29.99)).toFixed(2);
    }

    const capitalize = (word) => word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();

    const lineProperties = {
      "Name": profile?.name || "",
      "Gender": capitalize((profile?.gender || "").trim()),
      "Selected Format":
        selectedFormat === "premium"
          ? `Premium Cover (${symbol}${price})`
          : `Standard Book (${symbol}${price})`,
    };

    if (profile?.skinTone === "dark") {
      lineProperties["Character"] = "Dark skin tone";
    }

    if (isPhotoUploaded) {
      const addon = Math.ceil(Shopify.currency.rate * 3).toFixed(2);
      lineProperties["Photo Upload"] = `Yes (+${symbol}${addon})`;
    }

    // Lock + loader, backend (idempotent), cart add: see format-continue.js
    return laylSubmitBook({
      continueBtn,
      loader,
      errorElement,
      selectedFormat,
      selectedVariantId,
      lineProperties,
      buildFormData,
    });
  });
});
